module.exports = "/assets/images/question_d88254.svg";